module.exports = __webpack_public_path__ + "img/noFleet.5e689c83.png";